import modularRedux from '@exodus/modular-redux';
import { setupActions } from '@exodus/redux-dependency-injection/src/setup-redux';
import { composeWithDevTools as compose } from '@redux-devtools/extension';
import {
  applyMiddleware,
  bindActionCreators,
  legacy_createStore as createStore,
} from 'redux';
import thunk from 'redux-thunk';

import {
  createHandleEvent,
  initialState,
  ioc,
  reducers as mergedReducers,
} from './setup-redux.js';

const bindAllActionCreators = ({ dispatch }, actionCreators) => {
  const bindedActionCreators = {};
  Object.keys(actionCreators).forEach((ac) => {
    bindedActionCreators[ac] = bindActionCreators(actionCreators[ac], dispatch);
  });
  return bindedActionCreators;
};

const thunkExtraArgument = { store: null as any };
const middleware = [thunk.withExtraArgument(thunkExtraArgument)];

const enhancers = compose(
  modularRedux,
  applyMiddleware(...(middleware as unknown as any)),
);

function createContainer({ initialState: _initialState = {} }) {
  const store = createStore(
    mergedReducers as never, // The createStore type is not correct.
    { ...initialState, ..._initialState },
    enhancers,
  );
  thunkExtraArgument.store = store;

  const actionCreators = setupActions({ ioc });
  const dispatchReduxEvent = createHandleEvent(store);
  return { store, actionCreators, dispatchReduxEvent };
}

const { store, actionCreators, dispatchReduxEvent } = createContainer({
  initialState,
});

const actions = bindAllActionCreators(store, actionCreators) as any;

export { actions, dispatchReduxEvent, store };
